import api from '../axiosConfig'
export default {
    mutations: {
        Result: () => {
            return false
        }
    },
    actions: {
        PutResponse({ commit }, value) {
            return new Promise((resolve, reject) => {
                let config = {
                    headers: {
                        'x-api-key': localStorage.getItem('userToken')
                    }
                }
                commit('Result')
                api.put(value.url, value.data, config).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
    }
}